import React from 'react';

// Components
import LinkToCategory from './LinkToCategory'

const CategoryCard = ({ category }) => (
  <div className="category-card">
    <h3>{ category.name }</h3>
    <p>{ category.description }</p>
    <LinkToCategory category={category} text="Read More" />
  </div>
)

export default CategoryCard



// WEBPACK FOOTER //
// ./src/components/ResourceLibrary/CategoryCard.js